import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header1 from "../layout/header/header1";

import bannerImg from "../../images/banner/banner3.jpg";

import { withTranslation } from "react-i18next";

// Images
import bg4 from "../../images/background/bg4.jpg";
import Newsletters2025 from "../elements/newsletters-2025";


class Newsletters extends Component {
	componentDidMount() {

	}
	render() {
		const { t } = this.props;
		return (
			<>
				<Header1 />

				<div className="page-content bg-white">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("Newsletters_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("Newsletters_LinkHome")}</Link>
								</li>
								<li>{t("Newsletters_LinkNewsletters")}</li>
							</ul>
						</div>
					</div>

					<div className="content-block" id="content-area">
						<div
							className="popular-courses-bx"
							style={{
								backgroundImage: "url(" + bg4 + ")",
								backgroundSize: "cover",
							}}
						>
							<div className="section-area section-sp3">
								<Newsletters2025 />
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default Newsletters = withTranslation()(Newsletters);
